module.exports = __webpack_public_path__ + "assets/Retina-BlackItalic.212936915abbfeb715525695730b804c.woff";